module.exports = __webpack_public_path__ + "img/io.54068f3d.svg";